import { withStyles } from '@material-ui/core/styles';
import { PaginationItem } from '@material-ui/lab';
import { createStyles, Theme } from '@material-ui/core';

const NewsPaginationItem = withStyles((theme: Theme) =>
  createStyles({
    root: {
      borderRadius: 0,
      color: theme.palette.primary.dark,
      fontWeight: 'bold',
      minHeight: 45,
      minWidth: 45,
      padding: theme.spacing(2),
      marginRight: 0,
      border: `1px solid ${theme.palette.primary.contrastText}`,
      '&:focus': {
        color: theme.palette.common.white,
      },
      '&:hover': {
        backgroundColor: 'transparent',
      },
      [theme.breakpoints.up('sm')]: {
        minHeight: 50,
        minWidth: 50,
        marginRight: theme.spacing(4),
      },
    },
    page: {
      '&$selected': {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.common.white,
        '&:hover': {
          backgroundColor: theme.palette.primary.main,
        },
      },
    },
    selected: {},
  }),
)(PaginationItem);

export default NewsPaginationItem;
